import { createContext, useContext, useState } from "react";

const UrlParamsContext = createContext();

const useUrlParams = () => useContext(UrlParamsContext);

export { UrlParamsContext, useUrlParams };